/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-2",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminApi",
            "endpoint": "https://3pj4mlsvw6.execute-api.eu-west-2.amazonaws.com/dev",
            "region": "eu-west-2"
        },
        {
            "name": "AdminQueries",
            "endpoint": "https://2m9yyvuq8l.execute-api.eu-west-2.amazonaws.com/dev",
            "region": "eu-west-2"
        },
        {
            "name": "PrivateApi",
            "endpoint": "https://kri4fibhej.execute-api.eu-west-2.amazonaws.com/dev",
            "region": "eu-west-2"
        },
        {
            "name": "PublicApi",
            "endpoint": "https://qk4wcsfnfh.execute-api.eu-west-2.amazonaws.com/dev",
            "region": "eu-west-2"
        }
    ],
    "aws_cognito_identity_pool_id": "eu-west-2:42154760-13ce-4b4d-bb48-f9e31163c8c3",
    "aws_cognito_region": "eu-west-2",
    "aws_user_pools_id": "eu-west-2_dv9Hof6QU",
    "aws_user_pools_web_client_id": "l1ht807vqnffr4uspj6ela4ru",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL",
        "NAME"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_dynamodb_all_tables_region": "eu-west-2",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "11thcloudvideos-dev",
            "region": "eu-west-2"
        },
        {
            "tableName": "videos-dev",
            "region": "eu-west-2"
        }
    ]
};


export default awsmobile;
